var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center kpi-info-chart"},[(_vm.loading)?_c('i',{staticClass:"fa-light fa-3x fa-spinner fa-pulse fa-fw"}):_c('canvas',{ref:"myChart",attrs:{"width":"700","height":"225"}})])}
var staticRenderFns = []

export { render, staticRenderFns }